import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Add from "./Add";
import Edit from "./Edit";
import ListExaminees from "./ListExaminees";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

const Assessments = ({ visible, mekhraz_id }) => {
  const [exam, setExam] = useState({});
  const [isAdded, SetIsAdded] = useState(false);
  const [assessmentTypeOptions, setAssessmentTypeOptions] = useState([]);
  const [mazmeenTypeOptions, setMazmeenTypeOptions] = useState([]);
  const [evaluationInstitutes, setEvaluationInstitute] = useState([]);
  const [activeMoamads, setActiveMoamads] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const [counter, setCounter] = useState(0);
  const [examineesNumber, setExamineesNumber] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  const [loading, setLoading] = useState(true);

  const increment = () => {
    setCounter(counter + 1);
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get("/jobs/evaluationinstitute", {
          signal: controller.signal,
        });
        if (isMounted) {
          setEvaluationInstitute(response?.data);
        }
      } catch (err) {
        console.error(err);
        // navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getData();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "moamad?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setActiveMoamads(response.data.filter((item) => item.saf));
          setLoading(false);
        }
      } catch (err) {
        if (err.response) {
          alert("hhhh", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getAssessment = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "assessment?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setExam(response.data[0]);
        }
      } catch (err) {
        if (err.response) {
          alert("hhhh2", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getAssessment();

    const getAssessmentTypeOptions = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "assessmenttype/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setAssessmentTypeOptions(response.data[0].assessmentTypeOptions);
        }
      } catch (err) {
        if (err.response) {
          alert("hhhh3", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getAssessmentTypeOptions();

    const getMazmeenTypeOptions = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "mazmeentype/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setMazmeenTypeOptions(response.data[0].mazmeenTypeOptions);
        }
      } catch (err) {
        if (err.response) {
          alert("שגיאה:", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };

    getMazmeenTypeOptions();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isAdded]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          "/jobs/moamad?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setActiveMoamads(response.data.filter((item) => item.saf));
          setLoading(false);
        }
      } catch (err) {
        if (err.response) {
          alert("Status:", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isAdded]);
  if (!visible) return;
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else if (exam) {
    return (
      <>
        <Edit
          exam={exam}
          setExam={setExam}
          assessmentTypeOptions={assessmentTypeOptions}
          mazmeenTypeOptions={mazmeenTypeOptions}
          evaluationInstitutes={evaluationInstitutes}
          activeMoamads={activeMoamads}
          setExamineesNumber={setExamineesNumber}
          examineesNumber={examineesNumber}
          setShowAdd={setShowAdd}
        />
        <ListExaminees
          exam={exam}
          counter={counter}
          increment={increment}
          setExamineesNumber={setExamineesNumber}
          showAdd={showAdd}
          setShowAdd={setShowAdd}
          activeMoamads={activeMoamads}
        />
      </>
    );
  } else {
    return (
      <Add
        mekhraz_id={mekhraz_id}
        SetIsAdded={SetIsAdded}
        assessmentTypeOptions={assessmentTypeOptions}
        mazmeenTypeOptions={mazmeenTypeOptions}
        evaluationInstitutes={evaluationInstitutes}
      />
    );
  }
};

export default Assessments;
